import React from 'react';
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose';
import { get, find } from 'lodash';
import { withRouter } from 'react-router-dom';
import withLoader from '../../modules/app/withLoader';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { Grid, Table, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { SortingState, IntegratedSorting } from '@devexpress/dx-react-grid';
import { Link } from 'react-router-dom';
import { attributes } from './_api';
import { attributeLevel } from '../../utils/constants/';

const enhance = compose(
  withState('items', 'setItems', []),
  withRouter,
  withLoader,
  withHandlers({
    loadItems: ({ setItems, toggleLoader }) => async () => {
      toggleLoader();
      const resp = await attributes();
      if (resp) {
        setItems(resp.items);
      }
      toggleLoader(false);
    },
  }),
  lifecycle({
    async componentDidMount() {
      const { loadItems } = this.props;
      loadItems();
    },
    async componentWillReceiveProps(nextProps) {
      const { loadItems } = this.props;
      if (this.props.reload !== nextProps.reload) {
        loadItems();
      }
    },
  }),
  withHandlers({
    redirectTo: ({ history }) => (id) => {
      history.push(`/attributes/${id}`);
    },
  }),
  withHandlers({
    TableRow: ({ redirectTo }) => ({ row, ...restProps }) => (
      <Table.Row
        {...restProps}
        style={{
          cursor: 'pointer',
          ':hover': { background: '#7eb6e4' },
        }}
        onClick={() => redirectTo(get(row, 'id'))}
      />
    ),
  }),
  withProps(({ setDialog }) => ({
    columns: [
      { name: 'id', title: 'ID' },
      { name: 'name', title: 'Jméno' },
      { name: 'description', title: 'Popis' },
      {
        name: 'level',
        title: 'Příslušnost',
        getCellValue: (row) => get(find(attributeLevel, { id: row.level }), 'label'),
      },
      {
        name: 'delete',
        title: ' ',
        getCellValue: (row) => (
          <div>
            <Button
              variant="outlined"
              onClick={(e) => {
                e.stopPropagation();
                setDialog({ open: true, id: row.id, action: 'attribute-delete' });
              }}
            >
              Smazat
            </Button>
          </div>
        ),
      },
    ],
  }))
);

export default enhance(({ items, TableRow, columns }) => (
  <div style={{ margin: 10 }}>
    <Button
      variant="contained"
      color="primary"
      component={(props) => <Link to="/attributes/add" {...props} />}
      style={{ marginBottom: 20 }}
    >
      Přidat
    </Button>
    <Paper>
      <div className="grid--clickable grid--custom">
        <Grid rows={items || []} columns={columns}>
          <SortingState defaultSorting={[{ columnName: 'name', direction: 'asc' }]} />
          <IntegratedSorting />
          <Table rowComponent={TableRow} />
          <TableHeaderRow showSortingControls />
        </Grid>
      </div>
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/attributes/index.js